import { render, staticRenderFns } from "./ServiceHome.vue?vue&type=template&id=0b005503"
import script from "./ServiceHome.vue?vue&type=script&lang=js"
export * from "./ServiceHome.vue?vue&type=script&lang=js"
import style0 from "./ServiceHome.vue?vue&type=style&index=0&id=0b005503&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports